package com.milta.feature.admin.domain.usecase

import com.milta.feature.admin.domain.entity.AdminOcrAnalysis
import com.milta.feature.admin.domain.repository.AdminRepository

class GetAdminOcrAnalysisUseCase(private val repository: AdminRepository) {
    suspend operator fun invoke(): Result<AdminOcrAnalysis> = repository.getOcrAnalysis()
}
